// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"fdeab36f","488":"9734f5c0"}[chunkId] + ".chunk.js";
};